// eslint-disable-next-line react/react-in-jsx-scope
import * as React from 'react';
import GameRulesText from '../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray', margin: '0' }}>
      <GameRulesText game="repeat" />
    </p>
  </>
);

export default RulesOfTheGame;
